import { LogTypeEnum } from 'libs/monitoring/errors'
import { eventMonitoring } from 'libs/monitoring/services'
import { CitiesResponse } from 'libs/place/types'

const CITIES_API_URL = 'https://geo.api.gouv.fr/communes'

export const fetchCitiesByPostalCode = async (postalCode: string): Promise<CitiesResponse> => {
  const queryParams = new URLSearchParams()
  queryParams.append('codePostal', postalCode)
  const url = `${CITIES_API_URL}?${queryParams.toString()}`

  try {
    const response = await fetch(url)
    if (!response.ok) throw new Error('Failed to fetch cities')
    return await response.json()
  } catch (error) {
    eventMonitoring.captureException('Failed to fetch cities', {
      level: LogTypeEnum.INFO,
      extra: { error },
    })
    return []
  }
}
